<template>
  <div class="mdl2-2layer">
    <div class="mdl2-bottom">
      <!-- <div
        class="mr20"
        v-show="!$store.state.editStore.isSioEdit"
        @click="setSioEdit(true)"
        v-if="$get($store, 'state.permissions.44.allow')"
      >
        EDIT
      </div>
      <div
        class="mr20"
        v-show="$store.state.editStore.isSioEdit"
        @click="setSioCancel(false)"
        v-if="$get($store, 'state.permissions.44.allow')"
      >
        CANCEL
      </div> -->
      <div class="mr20" @click="setEdit()" v-if="$get($store, 'state.permissions.44.allow')">
        <!-- {{ $get($store, 'state.editStore.isEditInfo') ? 'CANCEL' : 'EDIT' }} -->
        {{
          editingStatus == 1 || editingStatus == true
            ? `CANCEL ( ${editingUser} )`
            : `EDIT`
        }}
      </div>
    </div>

    <div class="modal-level2-pagination">
      <div class="mlp-wrapper">
        <div>Tampilan Baris</div>
        <div class="mlp-rows-setting">
          <b-form-select v-model="totalPerPage" :options="modes" class="row-setting-wrapper"></b-form-select>
        </div>
        <div class="mlp-pagination-wrapper">
          <b-pagination aria-controls="isupplier-table" v-model="currentPage" :total-rows="2000"
            :per-page="totalPerPage" align="fill" class="mlp-pagination"></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage: 1,
      totalPerPage: 25,
      modes: [5, 10, 15, 25],
    }
  },
  computed: {
    editingStatus() {
      return this.$get(this.$store, 'state.editingStore.sio_level_1.is_open', 0)
    },
    editingUser() {
      return this.$get(
        this.$store,
        'state.editingStore.sio_level_1.open_by',
        ''
      )
    },
    editingId() {
      return this.$get(this.$store, 'state.editingStore.sio_level_1.id', '')
    },
  },
  methods: {
    setSioEdit(value) {
      this.$store.commit('editStore/SET_DATA', {
        name: 'isSioEdit',
        value,
      })
    },
    setSioCancel(value) {
      this.$store.commit('editStore/SET_DATA', {
        name: 'isSioEdit',
        value,
      })
    },
    setEdit() {
      if (this.editingStatus == 1 || this.editingStatus == true) {
        this.$store.dispatch('editingStore/deleteEditingStatus', {
          id: this.editingId,
          is_open: 0,
          open_by: this.$store.state.currentUser,
          user_id: this.$store.state.userid,
          vendor_id: this.$store.state.level1.vendorId,
          name: 'sio_level_1',
        })
      } else {
        this.$store.dispatch('editingStore/addEditingStatus', {
          is_open: 1,
          desc: 'sio_level_1',
          open_by: this.$store.state.currentUser,
          user_id: this.$store.state.userid,
          vendor_id: this.$store.state.level1.vendorId,
          name: 'sio_level_1',
        })
      }
      // this.$store.commit('SET_NOTIF', 'Maaf, Fitur sedang dalam pengembangan.')
    },
  },
}
</script>
